import React from 'react'
import NavBar from '../components/NavBar';
import TitleCard from '../components/TitleCard';
import Research from '../screens/Research';
import Footer from '../components/Footer';
const ResearchPage = (props) => {
  return (
    <>
        <NavBar />
        <TitleCard heading= "Research Initiatives" subHeading="Dive into Our Ongoing Projects and Discoveries"/>
        <Research />
        <Footer />
    </>
  )
}


export default ResearchPage